import { Component } from 'preact'
import axios from 'axios'
import Header from './Header'
import Sidebar from './Sidebar'
import Loader from '../ui-components/Loader'
import AlertComponent from '../ui-components/AlertComponent'
import DraftDeletedModal from './DraftDeletedModal'
import Editor from '../editor'
import globals from '../../utils/globals'
import tracker from '../../components/tracker/publish'
import DraftDeleteConfirmationModal from './DraftDeleteConfirmationModal'
import DraftPublishedModal from './DraftPublishedModal'

const errorMessages = {
  titleEmpty: 'Please add a title',
  titleTooShort: 'Title must contain at least 3 characters',
  forumIdEmpty: 'Please select a category'
}

const endpoints = {
  legacy: '/topic/_create',
  save: '/draft/save',
  publish: '/draft/publish'
}

class ArticleCreator extends Component {
  constructor (props) {
    super()
    const article = props.article || this.getDefaultArticleState()
    this.state = {
      ...article,
      content_type: 'article',
      isLoading: false,
      isDraft: null,
      draftSaved: false,
      triedToPublish: false,
      hasUnsavedChanges: false,
      showDraftDeletedModal: false,
      showDeletedConfirmationModal: false,
      showDraftPublishedModal: false,
      isDraftDeleted: false,
      errors: {
        title: '',
        forum_id: ''
      },
      backendErrors: {
        messageType: null,
        messageText: ''
      }
    }
    if (this.state.meta) this.setState({ articleId: this.state.meta.id, draftSaved: true })
    this.csrfToken = document.getElementById('csrftoken').value
    this.hasFileInProgress = false
    this.onCloseDraftDeleteModal = this.onCloseDraftDeleteModal.bind(this)
    this.onDelete = this.onDelete.bind(this)
    this.onCloseDeleteConfirmationModal = this.onCloseDeleteConfirmationModal.bind(this)
    this.onCloseDraftPublishedModal = this.onCloseDraftPublishedModal.bind(this)
    this.onEditorLoaded = this.onEditorLoaded.bind(this)
    this.onUnload = this.onUnload.bind(this)
    this.onTitleChanged = this.onTitleChanged.bind(this)
    this.onSidebarItemChanged = this.onSidebarItemChanged.bind(this)
  }

  getDefaultArticleState () {
    return {
      articleId: null,
      featured_image: null,
      forum_id: null,
      open: true, // allow replies
      public_label: null,
      sticky: false,
      tags: [],
      title: '',
      meta: null
    }
  }

  componentDidMount () {
    window.addEventListener('beforeunload', this.onUnload)
    window.addEventListener('editorLoaded', this.onEditorLoaded)
  }

  componentWillUnmount () {
    window.removeEventListener('beforeunload', this.onUnload)
    window.removeEventListener('editorLoaded', this.onEditorLoaded)
  }

  onUnload (e) {
    const { isDraftDeleted, hasUnsavedChanges, title: hasTitle } = this.state
    const quillEditor = document.querySelector('.ql-editor')

    const hasContent = quillEditor
      ? !quillEditor.classList.contains('ql-blank')
      : !!this.getEditorContent().content

    if (hasUnsavedChanges && (hasTitle || hasContent) && !isDraftDeleted) {
      e.preventDefault()
      e.returnValue = ''
    }
  }

  onEditorLoaded () {
    const { article } = this.props
    const { content: bbcode } = this.state
    const wysiwygEditor = global.app.editor.currentView.wysiwygEditor

    if (article) {
      const htmlContent = '<div>' + wysiwygEditor.transformDialectToHtml(bbcode) + '</div>'
      wysiwygEditor.insertHtml(htmlContent)
    }

    setTimeout(() => {
      wysiwygEditor.quill.on('text-change', () => {
        this.setHasUnsavedChanges()
      })
      window.addEventListener('attachmentsUpdated', () => {
        this.setHasUnsavedChanges()
      })
    }, 0)
  }

  getEditorContent () {
    const app = global.app
    if (!global.app.editor) {
      return {
        content: this.content,
        attachments: this.attachments,
        poll: this.poll
      }
    }
    return {
      content: app.editor.currentView.getContent(),
      attachments: app.editorModel.get('attachments'),
      poll: app.editorModel.get('poll'),
      survey_id: null
    }
  }

  getData (isDraft) {
    const commonData = Object.assign(this.state, this.getEditorContent())

    if (this.state.articleId) {
      return Object.assign(commonData, { article_id: this.state.articleId })
    } else {
      return Object.assign(commonData, { isDraft: isDraft })
    }
  }

  getEndpoint (isDraft) {
    return !this.props.allowDrafts ? endpoints.legacy : isDraft ? endpoints.save : endpoints.publish
  }

  handlePublishResponse (res) {
    const articleModerationPage = res.headers.location

    if (articleModerationPage) {
      const { content_type, title, forum_id, draftSaved } = this.state
      const { allowDrafts } = this.props
      const { userid, role } = window.inSidedData.user

      tracker.trackEvent('userevent', {
        'content_type': content_type,
        'event_source': 'control',
        'type': 'Topic Created'
      })

      if (allowDrafts) {
        tracker.trackEvent('userevent', {
          'type': 'Article Published',
          'article_id': res.data.id,
          'article_title': title,
          'article_category': forum_id,
          'author_id': userid,
          'author_role': role,
          'published_immediately': !draftSaved
        })
      }

      window.location.assign(articleModerationPage)
    }
  }

  handleSaveDraftResponse (res) {
    const base = window.location.origin
    const draftUrl = base + '/draft/' + res.data.id
    window.history.pushState(null, null, draftUrl)

    if (!this.state.draftSaved) {
      tracker.trackEvent('userevent', {
        'type': 'Article Draft Created',
        'article_title': this.state.title,
        'article_category': this.state.forum_id,
        'community_id': globals('communityId'),
        'author_id': window.inSidedData.user.userid,
        'author_role': window.inSidedData.user.role
      })
    }

    this.setState({
      isLoading: false,
      draftSaved: true,
      articleId: res.data.id || null,
      meta: {
        created_at: res.data.created_at,
        created_by: res.data.created_by,
        last_edited_by: res.data.last_edited_by,
        last_edited_at: res.data.last_edited_at
      },
      backendErrors: { messageType: null, messageText: '' }
    })
  }

  handlePostErrors (responseError) {
    if (responseError) {
      if (responseError.data && responseError.data.error === 'Article does not exist') {
        this.redirectToOverview(responseError.data.redirect)
        return
      }

      if (responseError.data.errors && responseError.data.errors[0] === 'Article does not exist') {
        this.setState({
          isDraftDeleted: true,
          showDeletedConfirmationModal: false,
          showDraftDeletedModal: true
        })
        return
      }

      if (responseError.status === 422 && responseError.config.method === 'delete') {
        this.setState({
          showDeletedConfirmationModal: false,
          showDraftPublishedModal: true,
          isLoading: false
        })
        return
      }

      const { errors } = responseError.data
      const errorsText = errors ? Object.values(errors).join('\n') : 'Something went wrong'

      this.setState({ backendErrors: { messageType: 'error', messageText: errorsText } })
    }
  }

  hasErrors () {
    this.validateTitle()
    this.validateCategory()

    return this.state.errors.title !== '' || this.state.errors.forum_id !== ''
  }

  validateTitle () {
    const title = this.state.title
    if (!title) {
      this.setError('title', errorMessages.titleEmpty)
    } else if (title.length < 3) {
      this.setError('title', errorMessages.titleTooShort)
    } else {
      this.setError('title', '')
    }
  }

  validateCategory () {
    const forumId = this.state.forum_id
    if (!forumId) {
      this.setError('forum_id', errorMessages.forumIdEmpty)
    } else {
      this.setError('forum_id', '')
    }
  }

  setError (key, value) {
    this.setState({
      errors: {
        ...this.state.errors,
        [key]: value
      }
    })
  }

  setHasUnsavedChanges () {
    if (!this.state.hasUnsavedChanges) {
      this.setState({ hasUnsavedChanges: true })
    }
  }

  onCloseDraftDeleteModal () {
    this.setState({ showDraftDeletedModal: false })
  }

  onCloseDeleteConfirmationModal () {
    this.setState({ showDeletedConfirmationModal: false })
  }

  onCloseDraftPublishedModal () {
    this.setState({ showDraftPublishedModal: false })
  }

  onTitleChanged (value) {
    const { triedToPublish } = this.state
    this.setState({ title: value })

    this.setHasUnsavedChanges()

    if (triedToPublish) {
      this.validateTitle()
    }
  }

  onSidebarItemChanged (field, value) {
    const { triedToPublish } = this.state
    this.setState({ [field]: value })

    this.setHasUnsavedChanges()

    if (triedToPublish && field === 'forum_id') {
      this.validateCategory()
    }
  }

  onPublish (isDraft) {
    this.setState({
      triedToPublish: true
    })

    if (this.hasErrors()) {
      return
    }

    if (this.hasFileInProgress) {
      this.setState({
        backendErrors: { messageType: 'error', messageText: 'Please wait for your files to be uploaded' }
      })

      return
    }

    this.setState({ isLoading: true, ...isDraft })

    axios.defaults.headers.common = {
      'X-CSRF-TOKEN': this.csrfToken
    }
    const endpoint = this.getEndpoint(isDraft)
    const data = this.getData(isDraft)

    axios.post(endpoint, data).then(res => {
      if (res.status !== 201) {
        this.setState({
          isLoading: false,
          backendErrors: { messageType: 'error', messageText: 'Something went wrong, please try again later' }
        })
        return
      }

      this.setState({ hasUnsavedChanges: false })

      if (isDraft) {
        this.handleSaveDraftResponse(res)
      } else {
        this.handlePublishResponse(res)
      }
    }).catch(error => {
      this.setState({ isLoading: false })
      const responseError = error.response || null
      this.handlePostErrors(responseError)
    })
  }

  redirectToOverview (url) {
    this.setState({ hasUnsavedChanges: false })
    window.location.assign(`${url}?deleted&title=${this.state.title}`)
  }

  onDelete () {
    const { articleId, title } = this.state

    this.setState({ isLoading: true })

    axios.defaults.headers.common = {
      'X-CSRF-TOKEN': this.csrfToken
    }
    axios.delete('/draft/delete', { params: { draftId: articleId, title: title }
    }).then(res => {
      this.redirectToOverview(res.data.redirect)
    }).catch(error => {
      const responseError = error.response
      this.handlePostErrors(responseError)
      this.setState({ isLoading: false })
    })
  }

  render (props, state) {
    const {
      title,
      forum_id,
      open,
      sticky,
      public_label,
      featured_image,
      tags
    } = state

    const { isLoading, draftSaved, hasUnsavedChanges, meta, errors, backendErrors, showDraftDeletedModal, showDeletedConfirmationModal, showDraftPublishedModal } = state
    const { allowDrafts, categories, phrases, isKnowledgeBaseEnabled, CKEditor } = props

    const labels = [
      phrases['topic.public_label.suggestion.blog'],
      phrases['topic.public_label.suggestion.news'],
      phrases['topic.public_label.suggestion.faq'],
      phrases['topic.public_label.suggestion.tutorial'],
      phrases['topic.public_label.suggestion.interview']
    ]

    return (
      <div>
        <Header
          allowDrafts={allowDrafts}
          draftSaved={draftSaved}
          hasUnsavedChanges={hasUnsavedChanges}
          title={title}
          error={errors.title}
          onTitleChanged={this.onTitleChanged}
          meta={meta}
          onPublish={() => this.onPublish(false)}
          onSaveAsDraft={() => this.onPublish(true)}
          onDeleteHandler={() => this.setState({ showDeletedConfirmationModal: true })}
        />
        {isLoading && <Loader />}
        <div className='topic-post'>
          <AlertComponent messageType={backendErrors.messageType} message={backendErrors.messageText} />
          <Editor
            isControl
            data={this.state.content}
            attachments={this.state.attachments}
            CKEditor={CKEditor || false}
            canHavePoll
            onPollUpdate={(poll) => { this.poll = poll }}
            onChange={(content, attachments, hasFileInProgress) => {
              this.content = content
              this.attachments = attachments
              this.hasFileInProgress = hasFileInProgress
              this.setHasUnsavedChanges()
            }} />
        </div>
        <Sidebar
          categories={categories}
          labels={labels}
          featuredImage={featured_image || ''}
          onUpdate={this.onSidebarItemChanged}
          error={errors.forum_id}
          allowReplies={open}
          sticky={sticky}
          forum_id={forum_id}
          public_label={public_label}
          tags={tags}
          isKnowledgeBaseEnabled={isKnowledgeBaseEnabled}
        />
        <DraftDeletedModal enableModal={showDraftDeletedModal} onClose={this.onCloseDraftDeleteModal} />
        <DraftPublishedModal enableModal={showDraftPublishedModal} onClose={this.onCloseDraftPublishedModal} />
        <DraftDeleteConfirmationModal enableModal={showDeletedConfirmationModal} onClose={this.onCloseDeleteConfirmationModal} onDelete={this.onDelete} />
      </div>
    )
  }
}

export default ArticleCreator
